import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-address-number-error-dialog',
  templateUrl: './address-number-error-dialog.component.html',
  styleUrls: ['./address-number-error-dialog.component.scss']
})
export class AddressNumberErrorDialogComponent implements OnInit {

  constructor( @Inject(MAT_DIALOG_DATA) public data: { showpicklocation:boolean }) { }

  ngOnInit(): void {
  }

}
